import { Image } from "@src/components/Image";
import React, { useEffect, useState, useRef } from "react";

import { getAwsAssets } from "@src/utils";

function Modal({
  customClass,
  customProps,
  children,
  handleClose=()=>{},
  header,
  blockBackdrop,
  footer,
  isBundle = "0",
  modalBackdropClass = null,
  isCloseButtonVisible = true
}) {
  const [returnContent, setReturnContent] = useState(true);

  // useEffect(() => {
  //   if (showModal) {

  //     setReturnContent(showModal);
  //   } else {

  //   }
  // }, [showModal]);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (returnContent) {
    } else {
      timeoutRef.current = setTimeout(() => {
        // handleClose={null} (e.g. CourseAccessRemovedBottomSheet) overrides the
        // default no-op and used to throw "handleClose is not a function".
        if (typeof handleClose === "function") handleClose();
      }, 300);
    }
    return () => clearTimeout(timeoutRef?.current);
  }, [returnContent]);

  return (
    <div
      className={
        returnContent
          ? "ModalWrapper blockSlide ModalWrapper__Show"
          : "ModalWrapper blockSlide ModalWrapper__Hide"
      }
    >
      <div
        onClick={() => {
          if (!blockBackdrop) {
            setReturnContent(false);
          }
        }}
        className={
          returnContent ? `Backdrop Backdrop__Show ${modalBackdropClass ? modalBackdropClass : ''}` : "Backdrop Backdrop__Hide"
        }
      />
      <div
        className={
          returnContent
            ? `Modal Modal__Show ${customClass ? customClass : ""}`
            : `Modal Modal__Hide ${customClass ? customClass : ""}`
        }
        style={{height : isBundle === "1" ? "90vh" : ""}}
        {...customProps}
      >
      {(handleClose && isCloseButtonVisible) ?
        <div
          className="Modal--Close"
          onClick={() => {
            setReturnContent(false);
          }}
        >
          <Image
            src={getAwsAssets("crossIcon.svg", "bottomSheets")}
            alt="X"
            width="24px"
            height="24px"
            layout="fixed"
            objectFit="cover"
          />
        </div>
          :
          null
      }
        <div
          className="Modal__Head"
          style={{
            borderBottom: header ? "1px solid #e5e5e5" : "",
          }}
        >
          {header ? <div className="Modal__Head--Details">{header}</div> : ""}
        </div>
        <div className="Modal__Body">{children}</div>

        {footer ? (
          <div
            className={
              returnContent
                ? "Modal__Footer Modal__Footer__Fixed"
                : "Modal__Footer Modal__Footer__Absolute"
            }
          >
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Modal;
